import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { PieChart } from "@mui/x-charts";

export type TPieChartData = {
  label: string;
  value: number;
  color?: string;
};

type TGenericPieChart = {
  data?: TPieChartData[];
  title?: string;
  innerRadius?: number;
  outerRadius?: number;
  paddingAngle?: number;
  cornerRadius?: number;
};

export const GenericPieChart = ({
  data,
  title = "",
  innerRadius = 40,
  outerRadius = 70,
  paddingAngle = 2,
  cornerRadius = 3,
}: TGenericPieChart) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(200);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        setHeight(width * 0.8);
      }
    });
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    return () => resizeObserver.disconnect();
  }, []);

  if (!data || data.length === 0)
    return <NoDataWrapper>No Data to display</NoDataWrapper>;

  return (
    <Wrapper>
      {title && <ChartTitle>{title}</ChartTitle>}
      <PieContainer ref={containerRef}>
        <PieChart
          height={height}
          legendPosition="bottom"
          series={[
            {
              data,
              highlightScope: { faded: "global", highlighted: "item" },
              faded: {
                innerRadius: innerRadius / 2,
                additionalRadius: -20,
                color: "gray",
              },
              innerRadius,
              outerRadius,
              paddingAngle,
              cornerRadius,
            },
          ]}
          sx={{
            "& .MuiChartsLegend-series tspan": { fontSize: "0.75em" },
          }}
        />
      </PieContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ChartTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  text-align: left;
  color: #1e293b;
`;

const PieContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NoDataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 0.8em;
  color: #64748b;
`;

export default GenericPieChart;
